import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import Select from "react-select";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditLeadType = ({ show, onClose, data, refresh }) => {
    const [name, setname] = useState('');
    const [contact, setcontact] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [existing, setExisting] = useState([]);

    useEffect(() => {
        if(data){
            setname(data.name);
            setcontact(data.contact);
            setDescription(data.description);
        }
    }, [data]);

    useEffect(() => {
        if (show) {
            axios.get(`${baseURL}/helpdesk`)
                .then(response => {
                    setExisting(response.data.data); // store full objects, not just contacts
                })
                .catch(error => {
                    console.error("Error fetching data", error);
                });
        }
    }, [show]);

    const validate = () => {
        const newErrors = {};
        const regex = /^[A-Za-z\s]+$/;
        if (!name) {
            newErrors.name = "This Field is Required.";
        }  else {
            if ((name === 1 || name === 3) && (!/^\d{10}$/.test(contact))) {
                newErrors.contact = "Please enter a valid 10-digit mobile number.";
            } else if (name === 2 && (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact))) {
                newErrors.contact = "Please enter a valid email address.";
            }
        }

        if (!contact.trim()) {
            newErrors.contact = "This Field is Required.";
        } else if (existing && data) {
            const duplicate = existing.find(
                (record) =>
                    record.sno !== data.sno &&
                    record.contact.toLowerCase() === contact.toLowerCase()
            );
            if (duplicate) {
                newErrors.contact = "This contact already exists.";
            }
        }

        return newErrors;
    };

    const handleUpdate = (e) => {
        e.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        axios.post(`${baseURL}/helpdesk/${data.sno}`, {
            name: name,
            contact: contact,
            description: description
        })
            .then(response => {
                onClose();
                refresh();
                toast.success("Contact Updated Successfully!");
            })
            .catch(error => {
                console.error("Error updating Lead type", error);
                toast.error("Contact Updation Failed");
            });
    };

    const contact_type = [
        { value: 1, label: "Contact Number" },
        { value: 2, label: "Email Address" },
        { value: 3, label: "WhatsApp Number" }
    ];

    return (
        <Modal show={show}  size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Contact</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleUpdate}>
                        <div className="row">
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Contact Type<span className="required">*</span></label>
                                {/* <input type="text" className="form-control" placeholder="Enter Lead Type" 
                                    value={name}
                                    onChange={(e) => setname(formatleadtypeName(e.target.value))}
                                /> */}

                                <Select
                                    options={contact_type}
                                    value={contact_type.find(typ => typ.value == name)}
                                    onChange={(e) => setname(e.value)}
                                    placeholder="Select Type"
                                />

                                {errors.name && <small className="text-danger">{errors.name}</small>}
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Contact<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Contact" 
                                    value={contact}
                                    onChange={(e) => setcontact(e.target.value)}
                                />
                                {errors.contact && <small className="text-danger">{errors.contact}</small>}
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Description</label>
                                <textarea rows={2} className="form-control h-auto" name="comment" placeholder="Description" 
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)} 
                                />
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                            <button type="submit" className="btn btn-sm btn-primary">Update Contact<i className="fas fa-angle-double-right ms-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default EditLeadType;
